import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UserService } from '../user.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private service: UserService) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.service.user) {
      return true
    }

    this.router.navigate(['/sessions/signin'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
